import { Box, Drawer, Grid } from "@mui/material";
import React from "react";
import { BrowseHome } from "./BrowseHome";
import { CollectionsAZ } from "./CollectionsAZ";
import { useMobile } from "../../hooks/useMobile";
import { useHomeStyles } from "./Home.style";
import { BrowseProvider } from "./contexts/browse.context";

export const ExploreScreen = (): JSX.Element => {
    const { isMobile, isTablet } = useMobile();

    const classes = useHomeStyles();

    return (
        <BrowseProvider>
            <Box display={"flex"} overflow="hidden" maxWidth={"100vw"} pt={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12} style={{ paddingRight: 0 }}>
                        {!isTablet && isMobile && <div className={classes.toolbar} />}
                        <BrowseHome />
                    </Grid>
                </Grid>

                {/* CollectionsAZ sidebar - hidden on all screen sizes per original logic */}
                <Box sx={{ display: "none" }}>
                    <Drawer
                        className={classes.homeDrawer}
                        variant="permanent"
                        classes={{ paper: classes.homeDrawerPaper }}
                        anchor="right"
                    >
                        <CollectionsAZ />
                    </Drawer>
                </Box>
            </Box>
        </BrowseProvider>
    );
};
